import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CountriesService } from '../../../services/countries/countries.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  contactType: 'email' | 'mobile_number' = 'email';
  selectedCountryCode: string = '+91';
  countries: any[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService,
    private countriesService: CountriesService,
  ) {
    this.router = router;
    this.countries = this.countriesService.getAllCountries();
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      mobileNumber: [''],
    });
  }

  setContactType(type: 'email' | 'mobile_number'): void {
    this.contactType = type;
    const emailControl = this.forgotPasswordForm.get('email');
    const mobileControl = this.forgotPasswordForm.get('mobileNumber');

    if (type === 'email') {
      emailControl?.setValidators([Validators.required, Validators.email]);
      mobileControl?.clearValidators();
      mobileControl?.setValue('');
    } else {
      mobileControl?.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9]{4,15}$/),
      ]);
      emailControl?.clearValidators();
      emailControl?.setValue('');
    }

    emailControl?.updateValueAndValidity();
    mobileControl?.updateValueAndValidity();
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.valid) {
      const identifier =
        this.contactType === 'email'
          ? this.forgotPasswordForm.value.email
          : `${this.selectedCountryCode}${this.forgotPasswordForm.value.mobileNumber}`;

      this.authService.forgotPassword(identifier, this.contactType).subscribe({
        next: (response) => {
          if (response.status === 'Operation successful') {
            const emailFromResponse = response?.data?.email as string | undefined;
            const resolvedEmail =
              this.contactType === 'email'
                ? identifier
                : emailFromResponse || identifier;

            if (this.contactType === 'mobile_number' && !emailFromResponse) {
              this.toastr.error(
                'Could not resolve account email. Please try again or use your email.',
                'Error',
              );
              return;
            }

            localStorage.setItem('email', resolvedEmail);
            localStorage.setItem('forgot_password_identifier', resolvedEmail);
            localStorage.setItem('forgot_password_identifier_type', 'email');
            const mobileNumber = response?.data?.mobile_number;
            if (mobileNumber) {
              localStorage.setItem('forgot_password_mobile_number', mobileNumber);
            }
            const successMessage = response?.message_key || response?.status;
            if (successMessage) {
              this.toastr.success(successMessage, 'Success');
            }
            this.router.navigate(['/otp']);
          }
        },
        error: (error) => {
          const errorMessage =
            error?.error?.message_key ||
            error?.error?.status ||
            'Something went wrong.';
          this.toastr.error(errorMessage, 'Error');
        },
      });
    }
  }
}
